<template>
  <div>
    <div 
      @click="launchFile()">
      <slot name="activator"></slot>
    </div>

    <input 
      type="file"
      accept="video/mp4,video/x-m4v,video/avi,video/mov,video/quicktime,video/*"
      ref="file"
      :name="filename"
      v-on:change="changeVideo($event.target.files)"
      style="display:none">

    <v-dialog 
      v-model="dialog"
      width="500">
      <v-card
        class="pa-0 ma-0"
        flat>
        <v-card
          color="red accent-2">
          <v-list-item>
            <v-list-item-avatar 
              color="red accent-2" 
              size="30">
              <v-icon color="white" large>mdi-alert</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-card-text 
                class="caption white--text pa-0">
                {{ message.error }}
              </v-card-text>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  export default {
    name: 'upload-folder',
    data: () => ({
      dialog: false,
      filename: 'file',
      message: {
        success: '',
        error: ''
      },
      process: {
        form: false
      }
    }),
    computed: {
      baseurllocal () {
        return this.$store.state.baseurllocal
      }
    },
    methods: {
      launchFile () {
        this.$refs.file.click()
      },
      changeVideo (file) {
        let video = file[0]
        if (file.length > 0) {
          if (video.type != 'video/mp4' && video.type != 'video/x-m4v' && video.type != 'video/avi' && video.type != 'video/mov' && video.type !== 'video/quicktime' && video.type != 'video/*') {
            this.dialog = true
            this.message.error = 'Silahkan pilih video dengan format .mp4 / .avi / .m4v / .mov'
          } else {
            let formData = new FormData()
                formData.append('file', video)
                formData.append('type', 'assets')

            this.process.form = true
            this.$emit('input', {
              process : this.process.form
            })

            let BASEURLLOCAL = this.baseurllocal !== '' && this.baseurllocal !== null ? this.baseurllocal  + '/' : process.env.VUE_APP_API_CDN

            fetch(`${BASEURLLOCAL}upload`, {
              method: 'POST',
              body: formData
            })
            .then(res => res.json())
            .then(response => {
              this.process.form = false

              // this.$emit('input', response.result)

              this.$emit('input', {
                file_name: response.results.data.filename,
                file_url: response.results.data.fileuri
              })
            })
          }
        }
      }
    }
  }
</script>